import React from 'react';
import Marquee from 'react-fast-marquee';

const clients = ['MARRIOTT', 'HILTON', 'EMAAR', 'DAMAC', 'ACCOR', 'NAKHEEL', 'MERAAS', 'GENSLER', 'ALDAR', 'SOBHA'];

export const ClientsMarquee = () => {
  return (
    <section className="py-6 md:py-8 border-y border-black/5 bg-gallery" data-testid="clients-marquee">
      <Marquee speed={30} gradient={true} gradientColor="#F5F5F0" gradientWidth={60}>
        {clients.map((name, i) => (
          <span key={i} className="mx-8 md:mx-12 font-display text-sm md:text-base font-bold text-obsidian/15 tracking-[0.15em]">
            {name}
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default ClientsMarquee;
